import { Component, computed, inject, output, viewChild } from '@angular/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { BaseModule } from 'shared/base/base.module'
import { HtButtonIntent } from 'shared/base/ht-button/ht-button.component'
import {
  HtModalComponent,
  HtModalOptions,
} from 'shared/base/ht-modal/ht-modal.component'

@Component({
  selector: 'login-ens-modal',
  imports: [BaseModule, TranslatePipe],
  templateUrl: './login-ens-modal.component.html',
  styleUrl: './login-ens-modal.component.scss',
})
export class LoginEnsModalComponent {
  private translate = inject(TranslateService)

  readonly modal = viewChild<HtModalComponent>('modal')

  closed = output<void>()

  readonly modalOptions = computed<HtModalOptions>(() => ({
    title: {
      text: this.translate.instant('auth.login.ensModal.title'),
    },
    size: 'small',
    rightBtnArray: [
      {
        show: true,
        text: this.translate.instant('auth.login.ensModal.continue'),
        intent: HtButtonIntent.PRIMARY,
        click: () => {
          this.onClose()
        },
      },
    ],
  }))

  open() {
    this.modal().open()
  }

  onClose() {
    this.modal().close(false)
    this.closed.emit()
  }
}
